import QrReader from "react-qr-reader";
import React, { useState, useEffect } from "react";
import notification from "../../services/notification";
import queryString from "query-string";
import { createResult } from "../../graphQLModel/mutations";
import http from "../../services/httpService";
import gql from "graphql-tag";
import auth from "../../services/authService"

const initialLocationState = {
  latitude: null,
  longitude: null,
};

export default function QRScanner(props) {
  let mounted = true;
  const [used, setUsed] = useState(false);
  const [{ latitude, longitude, speed }, setLocation] = useState(
    initialLocationState
  );

  const checkGeolocationAvailable = async (event) => {
    const result = await navigator.permissions.query({ name: "geolocation" });
    if (result.state == "granted") {
      if (mounted) {
        setLocation({
          latitude: event.coords.latitude,
          longitude: event.coords.longitude,
        });
      }
    } else if (result.state == "prompt") {
      notification.error("Geolocation is not enabled");
      setLocation(initialLocationState);
    } else if (result.state == "denied") {
      notification.error("Geolocation is  enabled");
      setLocation(initialLocationState);
    }
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(checkGeolocationAvailable);
    const watchId = navigator.geolocation.watchPosition(
      checkGeolocationAvailable
    );
    return () => {
      mounted = false;
      navigator.geolocation.clearWatch(watchId);
    };
  });

  const handleScan = (data) => {
    try {
      if (data) {
        setUsed(true);
        var result = queryString.parseUrl(data);
        if (result && result.query && result.query.result) {
            const decrypt = window.atob(result.query.result);
            if (decrypt) {
              const jsonResult = JSON.parse(decrypt);
              if(jsonResult.answer == "00000"){
                notification.success("Access Granted");
                sendData();
                console.log(latitude);
                console.log(longitude);
              } else {
                notification.error("Access Denied")
              }
            }
        }
      }
      setUsed(false);
    } catch (error) {
      setUsed(false);
    }
  };

  const handleError = (err) => {
    notification.error(err.toString());
  };

  const sendData = async () => {
    const result = await http.mutate({
      mutation: gql(createResult),
      variables: {
        input: {
          device: auth.DeviceId(),
          org: "hamzeh",
          result: "Access Granted",
        },
      },
    });

    console.log(result);
  }

  const handleTest = () => {
  };

  return (
    <div style={{ height: "100%" }}>
      {!used && (
        <QrReader
          className="ebrahim"
          delay={500}
          showViewFinder={false}
          onError={handleError}
          onScan={handleScan}
          style={{ width: "100%", height: "100%" }}
        />
      )}
    </div>
  );
}
